import React from 'react';

interface TextCellRenderProps {
    value: string | number;
}

export const TextCellRender = ({ value }: TextCellRenderProps) => {
    return (
        <span>{value}</span>
    );
};